<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <detail-list :col="2" size="small">
        <detail-list-item :term="$t('设备编号')">{{model.meterid}}</detail-list-item>
        <!--<detail-list-item term="告警状态">{{model.metertype == 1||model.metertype == 3?pressWarnList[model.warnstatus]:waterWarnList[model.warnstatus]}}</detail-list-item>-->
        <detail-list-item :term="$t('告警状态')"><span :style="{color: model.warnstatus == 0?'green':'red'}">{{model.warnstatus == 0?$t('正常'): model.datainfo}}</span> </detail-list-item>
        <detail-list-item :term="$t('上传时间')">{{model.systime}}</detail-list-item>
        <detail-list-item :term="$t('表端时间')">{{model.metertime}}</detail-list-item>
        <detail-list-item :term="$t('表类型')">{{'wq_device_type'|filterDictTextByCache(model.deviceType)}}</detail-list-item>
        <detail-list-item :term="model.deviceType == 'PM'?$t('压力值(MPa)'): $t('液位值(m)')">{{model.pvalue}}({{$t('告警上限')}}: {{model.pvalueTop}},{{$t('告警下限')}}: {{model.pvalueLow}})</detail-list-item>
        <detail-list-item :term="$t('温度值(℃)')">{{model.tepvalue}}</detail-list-item>
        <detail-list-item :term="$t('电压值(%)')">{{model.battery}}</detail-list-item>
        <detail-list-item :term="$t('信号值')">{{model.signDb}}</detail-list-item>
        <detail-list-item :term="$t('电池状态')">{{batterystatusList[model.batterystatus]}}</detail-list-item>
        <detail-list-item :term="$t('上报方式')">{{tuopuruiSendWayObj[model.metersendway]?$t(tuopuruiSendWayObj[model.metersendway]): $t('未知')}}</detail-list-item>
        <detail-list-item :term="$t('传感器状态')">{{sensorstatusList[model.sensorstatus]}}</detail-list-item>
        <!--<detail-list-item  :col="1" term="备注">{{model.remark}}</detail-list-item>-->
      </detail-list>
    </a-spin>
  </j-modal>
</template>

<script>

  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {tuopuruiSendWayObj} from '@/utils/constants/protocolConstant'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  export default {
    name: 'PartPwHistoryMeterdatarecordModal',
    filters: {
      filterDictTextByCache
    },
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        tuopuruiSendWayObj,
        width:800,
        visible: false,
        disableSubmit: false,
        model: {},
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/meter/partPwHistoryMeterdatarecord/add",
          edit: "/jeecg-charge/meter/partPwHistoryMeterdatarecord/edit",
          queryById: "/jeecg-charge/meter/partPwHistoryMeterdatarecord/queryById"
        },
      }
    },
    computed: {
      title() {
        return this.$t('详情')
      },
      metertypeList() {
        return {1: this.$t('NB压力表'),2: this.$t('NB液位计'),3: this.$t('4G压力表'),4: this.$t('4G液位计')}
      },
      batterystatusList() {
        return {0: this.$t('正常'),1: this.$t('欠压')}
      },
      sensorstatusList() {
        return {0: this.$t('正常'),1: this.$t('异常')}
      },
      waterWarnList() {
        return {'-1': this.$t('离线'),0: this.$t('正常'),10: this.$t('液位下限报警'),20: this.$t('液位上限报警'),1: this.$t('温度下限报警'),2: this.$t('温度上限报警'),
        11: this.$t('液位下限报警、温度下限报警'),12: this.$t('液位下限报警、温度上限报警'),21: this.$t('液位上限报警 温度下限报警'),22: this.$t('液位上限报警 温度上限报警'),9: this.$t('电池电量报警')}
      },
      pressWarnList() {
        return {'-1': this.$t('离线'),0: this.$t('正常'),10: this.$t('压力下限报警'),20: this.$t('压力上限报警'),1: this.$t('温度下限报警'),2: this.$t('温度上限报警'),
        11: this.$t('压力下限报警、温度下限报警'),12: this.$t('压力下限报警、温度上限报警'),21: this.$t('压力上限报警 温度下限报警'),22: this.$t('压力上限报警 温度上限报警'),9: this.$t('电池电量报警')}
      },
    },
    created () {
    },
    methods: {
      close () {
        this.$emit('close');
        this.visible = false;
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      handleOk () {
        const that = this;
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>